<template>
  <b-col md="3" sm="3" xl="3" class="text-center animated fadeIn fadeOut">
    <b-card :bg-variant="wf.detect > 0 ? 'warning' : 'success'" @click="detail(wf)" :style="{ cursor: 'pointer'}">
      <!-- <h6><strong>{{item.name || '-'}}</strong></h6> -->
      <!-- <h6>{{item.host}}@{{item.ip_addr}}<br></h6> -->
      <!-- <b-badge variant="success" v-if="!item.ms == 0 ">Online ({{item.ms}} ms)</b-badge> -->
      <b-badge variant="light" style="width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
        <b-badge :variant="wf.ip_addr ? 'info' : 'primary'"> {{wf.ip_addr ? 'Server' : 'Domain'}} </b-badge>
        {{wf.name}}
      </b-badge>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ['wf'],
  methods: {
    detail: function(wf) { this.$router.push(`integrity/detect`); },
  },
  created () { console.info('agent-item.vue created') },
  destroyed () { console.log('agent-item.vue destroyed') },
  mounted () {  console.log('agent-item.vue mounted'); this.$forceUpdate(); },
}
</script>
